import queryString from 'query-string';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_USERS: (query) => ({ query }),
    API: {
      GET_USERS: apiResourceActionCreator('users')
    }
  }
})

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}/getUsers?${queryString.stringify(query)}`, authToken, action.admin.api.getUsers)

function* getUsers(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.query));
}

const configuration = {
  name: 'getUsers',
  action: action,
  sagas: getUsers,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingUser: true
    }),
    success: (state, action) => {
      const newUsers = action.payload.users.result;
      const updatedUserData = (!state.userData || action.payload.users.skip === 0) ?
        action.payload.users : {
          ...state.userData,
          result: state.userData.result
            .filter((profile) => !newUsers.map((newUser) => newUser.user.id).includes(profile.user.id))
            .concat(newUsers)
        }
      return ({
        ...state,
        isFetchingUser: false,
        userData: updatedUserData
      })
    },
    failed: (state, action) => ({
      ...state,
      isFetchingUser: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getUsers.js